import { render, staticRenderFns } from "./AutoTagRuleManager.vue?vue&type=template&id=13d86b26&lang=pug"
import script from "./AutoTagRuleManager.vue?vue&type=script&lang=ts"
export * from "./AutoTagRuleManager.vue?vue&type=script&lang=ts"
import style0 from "./AutoTagRuleManager.vue?vue&type=style&index=0&id=13d86b26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports